import React from "react";
import { BsInfoCircle } from "react-icons/bs";
import { Tooltip as ReactTooltip } from "react-tooltip";
import ColorDescriptionComponent from "./ColorDescriptionComponent";
const InfoRow = ({ label, value, className, description = "" }) => (
 <div className="flex justify-between border-b border-gray-300 pb-1">
    
    {/* Label + tooltip */}
    <div className="flex items-center gap-x-1">
      <p className="text-gray-600 font-medium">{label}:</p>
      {description && (
        <>
          <BsInfoCircle
            size={16}
            data-tooltip-id={`vehicle-description-${label}`}
            className="font-extrabold animate-pulse cursor-pointer"
          />
          <ReactTooltip
            className="text-16 z-50"
            id={`vehicle-description-${label}`}
            content={
              <ColorDescriptionComponent tooltipDescription={description} />
            }
          />
        </>
      )}
    </div>

    {/* Value */}
    <span style={{ color: className }}>{value}</span>
  </div>
);

export default InfoRow;
